import { FormatRule, SignOptions } from '../types';
import { formatNumber } from '../utils/formatNumber';
import { editSign } from '../utils/editSign';
import { replaceHyphen } from '../utils/replaceHyphen';

interface NumberFormatter {
  value: number;
  rule?: FormatRule;
  sign?: SignOptions;
  locale?: string;
}

export const numberFormatter = ({
  value,
  rule = 'as is',
  locale,
  sign = 'default'
}: NumberFormatter) => {
  if (!locale && typeof window !== 'undefined') {
    locale = window.navigator.language;
  }

  const { formattedNumber, decimalLength } = formatNumber(value, rule, locale);

  const rounded = +value.toFixed(decimalLength);

  const formattedSign = editSign({ formatted: formattedNumber, rounded, withSign: sign });
  const formattedHyphen = replaceHyphen(formattedSign);

  return { formatted: formattedHyphen, rounded };
};
